/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

type PayPalKeys = {
  clientID: string;
  secret: string;
  env: string;
};

export type ConfigKeys = {
  cognitoPoolID: string;
  cognitoClientID: string;
  playerScript: string;
  paypal: PayPalKeys;
};

var keys: ConfigKeys;

if (process.env.NODE_ENV === "production") {
  // in production, return the prod set of keys
  // module.exports = require("./prod"); // import and export at the same time
  keys = require("./prod");
} else {
  // in dev, return the dev set of keys
  // module.exports = require("./dev"); // import and export at the same time
  keys = require("./dev");
}

export default keys;
